import { render, staticRenderFns } from "./CrossSection.vue?vue&type=template&id=1b9a8f72&scoped=true"
import script from "./CrossSection.vue?vue&type=script&lang=js"
export * from "./CrossSection.vue?vue&type=script&lang=js"
import style0 from "./CrossSection.vue?vue&type=style&index=0&id=1b9a8f72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9a8f72",
  null
  
)

export default component.exports